var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "matrix(-1 0 0 1 20 0)",
    fill: "url(#pattern0_1638_17370)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 11,
    width: 12,
    height: 12,
    fill: "url(#pattern1_1638_17370)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1638_17370",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1638_17370",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_1638_17370",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1638_17370",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1638_17370",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACe0lEQVR4nO2ZS27UQBRFPeGzCFbARwxYANOmnhgg6mUaUhVlFnYSRBMEElvhIzGCIRKfhQSGQUHVSgshoN1x275u+xyppJ60VbrH75X9XFUAAAAAAAA13PNHtyymefD0xWL+UVb5HTw/tZ10kwA7YjY7vBI8vQgx/TTPZ/9awfOpxfTc3S93tY/Jhm8xv/tf8H+v9BYJLRJifrl++MtqSMdt7mHSPX9V21nVju4/3L9Rd3274HVlq5x3nj8Gz49LR+jv7i+Ha+NNpyd11zd1sA1WiPnT7MH+tV4EmOevG2z08xgF2FJCH5UQPJ803qTnk7EKsIWEdIgAF0qI6UPnAmhBeaMKlx7CwfPRGoLPtnl1LqCMFxZvuBcP/3Tme9cR0AJlvNCgP86rEWDqCiiUsULw/Gb98PPrOwcHl6oRYEMQ8FtCOl7Vjs6HcfOxhD8oAUvKeKG84ZaXrODp+2ItfuejdXr+tmFDEzA1DAFaECAGAVMXYDt7t83zM4vp2/lMXP72aT0GIhNwd3f3aoj5VZOPMQhoIXyL+b06TJtqBZQ7Xx2kTVVA6fnb1nZsTALKuEEdok1ZwOJpZwBB2lQFlNmOOkSbsoBtC6hrECAGAWIQIAYBYhAgBgFiECAGAWIQIAYBYhAgBgE1dD2bQkANCBj4uNioAASM+nuAUQEIaBUq4E94CqqBFtTzU4cNfFWbot6gDSBEBLg+SCrA9WF2UeG0IEcAZ8Aq1HeIDaCN0IJcH+Rgz4Cu/z95ECAGAWIQIAYBYhAgBgFiECAGAWIQIAYBYhAgBgFiECAGAWIQIAYBYhAgBgFiECAGAWIQIAYBYhAAAAAAAABQdcovQwsd66XK+pAAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_1638_17370",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACaklEQVR4nO2dTW5UMRCE3wYOA+w4RHBl1Y3mAIlbOQ0kExCnITkF5CD52RECMj+rSJlF9Fw9dn1Sb8dVXXb7SSO9tyxCCCHESsDj11O1kMmub3iDSK5veINIrm94g0iub3iDSK5veINIrm94g0iub3iDSK5vJ4d2/AZWt7D6HRZ3uwztfVnc/fVat807rfGbzeZl8fqlWP1Jb4pzqljcw+Jz60X35sPrJbsByFIWF11DaDufbtpzVfH6qUvz29z7c/QSmEaiaj05eB+vVw+geJyzzSJpFY/T1QOAxRXbKJJW8fjWIYB6yzaKpFU8btYPIIFRJC4F4AqAvguhE8BvBDSC+M0AoXQHuAKg70LoBPAbAY0gfjNAKN0BrgDouxA6AfxGYNYRtAwO2P7pAsjQ/dMFkKH7pwsgQ/dPF0CG7p8ugAzdP10AGbp/ugAydP90AWTo/ukCyND90wWQofunCyBD988WgMnXpwvA5OvTBWDy9ekCMPn6dAGYfH26AEy+Pl0AJl+fLgCTr7+6AOz4/edWdv90AVAACuAp4PGgE+DUEaQAoACmvgMeNIJcAegE+KCPoXuw/tgjaA/WVwBQADoB0AgKjSDdAaFLGLqE9RSEmR5D2Uz/GMpGAZBRAGQUABkFQEYBkFEAswfQXk669t+G2NeyuF49AL26OLivLi5ez+g7zZOWxYfVA2ivaNfr6+Px7re4f7c5erX0oH22g77bPFlZ3S5dP2FicUE37TmqWP369uTkRbcA/ofQPtsx9ziqP9rO7978R3eCx2l7Apji2wJWb/95/dht5gshhBBCCCGEEEKIZQR+A01ZXIZoB9TvAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtector);
export default __webpack_public_path__ + "static/media/protector.4c7a7de9dc5acef32b436f108280f5c4.svg";
export { ForwardRef as ReactComponent };